function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "android-unlock",
  d: "M15.416,7.567H14.8V6.329a3.1,3.1,0,0,0-6.19,0H9.783a1.919,1.919,0,1,1,3.838,0h0V7.567H7.988A1.242,1.242,0,0,0,6.75,8.806V15a1.242,1.242,0,0,0,1.238,1.238h7.428A1.242,1.242,0,0,0,16.654,15V8.805A1.242,1.242,0,0,0,15.416,7.567ZM11.7,13.2a1.238,1.238,0,1,1,1.238-1.238A1.242,1.242,0,0,1,11.7,13.2Z",
  transform: "translate(-6.75 -3.234)",
  fill: "#00e5ae"
});

var SvgLockOpen = function SvgLockOpen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9.904,
    height: 13,
    viewBox: "0 0 9.904 13",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock-open.cd51f4aa.svg";
export { ForwardRef as ReactComponent };